"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.letMeMap = letMeMap;
/** Type workaround for https://github.com/Microsoft/TypeScript/issues/7294#issuecomment-465794460 */
function letMeMap(array) {
  return array;
}